/*
  Stock badge on the product page ("In Stock" / "Pre-order"), rendered in sections/main-product.liquid.
  On variant change the badge is taken from the section HTML already fetched by product-info.js,
  so the stock check and the translated texts stay on the server.
*/
if (!customElements.get('variant-stock-status')) {
    customElements.define(
        'variant-stock-status',
        class VariantStockStatus extends HTMLElement {
            connectedCallback() {
                this.sectionId = this.dataset.sectionId;
                this.variantChangeUnsubscriber = subscribe(
                    PUB_SUB_EVENTS.variantChange,
                    this.handleVariantChange.bind(this)
                );
            }

            disconnectedCallback() {
                this.variantChangeUnsubscriber?.();
            }

            handleVariantChange({ data }) {
                if (data.sectionId !== this.sectionId || !data.html) return;

                const container = document.getElementById(`stock-status-${this.sectionId}`);
                const source = data.html.getElementById(`stock-status-${this.sectionId}`);
                if (!container || !source || container.innerHTML === source.innerHTML) return;

                container.innerHTML = source.innerHTML;
                this.animateStatusUpdate(container);
            }

            animateStatusUpdate(container) {
                container.style.opacity = '0';
                container.style.transition = 'opacity 0.2s ease-out';

                setTimeout(() => {
                    container.style.opacity = '1';
                    container.style.transition = 'opacity 0.3s ease-in';
                }, 50);
            }
        }
    );
}
